export const MEASUREMENT_ID = 'G-DB5EPRKKW4';

export function publicPagePath(pathname: string): string {
  const path = String(pathname || '/').split('?')[0].split('#')[0] || '/';
  return path.replace(/^\/quote\/[^/]+/, '/quote');
}

export function shouldRecordAnalytics(pathname: string): boolean {
  const path = String(pathname || '/').split('?')[0].split('#')[0] || '/';
  return path !== '/admin' && !path.startsWith('/admin/') && !path.startsWith('/blog/preview');
}

export function recordEvent(name: string, params: Record<string, unknown> = {}): void {
  if (typeof window === 'undefined' || !shouldRecordAnalytics(window.location.pathname)) return;
  const gtag = (window as Window & { gtag?: Gtag }).gtag;
  if (!gtag) return;
  gtag('event', name, params);
}

type Gtag = (...args: unknown[]) => void;

export function recordPageView(pathname: string, title = ''): void {
  if (!shouldRecordAnalytics(pathname)) return;
  const gtag = (window as Window & { gtag?: Gtag }).gtag;
  if (!gtag) return;
  const pagePath = publicPagePath(pathname);
  gtag('event', 'page_view', {
    page_path: pagePath,
    page_location: `${window.location.origin}${pagePath}`,
    page_title: title,
  });
}
